module.exports = __webpack_public_path__ + "static/media/drumless_tracks_tile.66beb9ab.jpg";